import { atom } from "recoil";

export const loggedInUser = atom({
  key: "loggedInUser",
  default: {},
  persistence_UNSTABLE: {
    type: "loggedInUser",
  },
});

export const chatActiveContact = atom({
  key: "chatActiveContact",
  persistence_UNSTABLE: {
    type: "chatActiveContact",
  },
});

export const chatSupportActiveContact = atom({
  key: "chatSupportActiveContact",
  persistence_UNSTABLE: {
    type: "chatSupportActiveContact",
  },
});

export const chatMessages = atom({
  key: "chatMessages",
  default: [],
  persistence_UNSTABLE: {
    type: "chatMessages",
  },
});

export const supportChatMessages = atom({
  key: "supportChatMessages",
  default: [],
  persistence_UNSTABLE: {
    type: "supportChatMessages",
  },
});
